import type { RouteLocationRaw, RouteParamsRawGeneric, RouteRecordNameGeneric } from 'vue-router'
import { isEqual, isObject } from 'lodash-es'
import { type MaybeRef, watch, isRef } from '@/composition/vue/compositionApi'
import { getRoutePrefetchService } from '@/core/container/ioc'
import { isStringArray } from '@/utils/string/isStringArray'

export const useRoutePrefetch = (
  routes: MaybeRef<RouteRecordNameGeneric[]> | MaybeRef<RouteLocationRaw[]>,
  params?: RouteParamsRawGeneric,
) => {
  const routePrefetchService = getRoutePrefetchService()

  const prefetch = (routeList: RouteRecordNameGeneric[]) => {
    for (const route of routeList) {
      routePrefetchService.prefetchChunksForRoute(route, params)
    }
  }

  const doPrefetch = (value: RouteRecordNameGeneric[] | RouteLocationRaw[]) => {
    if (isStringArray(value)) {
      prefetch(value)
    } else {
      const routeNames = value
        .map<RouteRecordNameGeneric>((route: RouteRecordNameGeneric | RouteLocationRaw) => {
          if (typeof route === 'string') {
            return route
          }

          return isObject(route) && 'name' in route ? route.name : undefined
        })
        .filter(Boolean)

      prefetch(routeNames)
    }
  }

  if (isRef(routes)) {
    watch(
      () => routes.value,
      (value, oldValue) => {
        if (isEqual(value, oldValue)) {
          return
        }

        doPrefetch(value)
      },
      { immediate: true },
    )
  } else {
    doPrefetch(routes)
  }
}
